export default __webpack_public_path__ + "static/media/num-icon4.5fdce59f.svg";